import React from 'react';
import { Typography, Grid, Box } from '@mui/material';

function ResourceDetails(props) {
  const classes = {
    title: {
      marginTop: '2px',
      padding: '10px',
    }
  }

  const { resource, vehicleType, domain, propertyNumber } = props.formValues;

  return (
    <Grid item xs={12} sm={6}>
      <Typography
        fontWeight={400}
        variant="h5"
        gutterBottom
        sx={classes.title}>
        Recurso
      </Typography>
      <Box pl={1} sx={{ paddingLeft: '10px', paddingBottom: '10px' }}>
        <Typography
          gutterBottom
        >
          Tipo: {resource}
        </Typography>
        {resource === 'Rodado' ?
          <>
            <Typography
              gutterBottom
            >Tipo de vehículo: {vehicleType}
            </Typography>
            <Typography
              gutterBottom
            >Patente: {domain}
            </Typography>
          </>
          :
          <Typography gutterBottom>Número de partida: {propertyNumber}</Typography>
        }
      </Box>
    </Grid>
  );
}

export default ResourceDetails;